import { useState } from 'react';
import MainLayout from '../../../components/layout/MainLayout';
import SearchFilters from './components/SearchFilters';
import UserTable from './components/UserTable';
import UserDetailModal from './components/UserDetailModal';
import { User } from './types';

export default function UserListPage() {
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  const handleViewDetail = (user: User) => {
    setSelectedUser(user);
    setDetailModalOpen(true);
  };

  return (
    <MainLayout>
      <div className="space-y-5">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold text-gray-900">用户列表</h1>
        </div>

        <SearchFilters />

        <UserTable
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          onViewDetail={handleViewDetail}
        />
      </div>

      {detailModalOpen && selectedUser && (
        <UserDetailModal
          user={selectedUser}
          onClose={() => setDetailModalOpen(false)}
        />
      )}
    </MainLayout>
  );
}
